import Vue from 'vue';
import VueGtag from 'vue-gtag';
import router from '@/router';
import { Constants } from '../constants';

Vue.use(
  VueGtag,
  {
    config: { id: Constants.GooglAnalyticsId },
    // enabled false will delay the initialization of google analytics until the optIn function of gtag is called.
    // This can be used for GDPR purposes.
    enabled: false,
  },
  router,
);
